
import './style/common.css';

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router/index'
import store from './store'
import './config/rem'
import App from './App'
import Qs from 'qs'
import {GetQueryString,getWxAuth,checkScenicAuth,getScenicAuth} from './utils/author'
import {setStore, getStore, removeStore} from './config/mUtils'
import {wxInitial} from './utils/wechat'
import VueLazyload from 'vue-lazyload'  //引入这个懒加载插件
Vue.use(VueLazyload);


//挂载swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper);

//import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill();

//提示弹窗
import {Alert, Confirm, Toast, Loading} from './wc-messagebox'

Vue.use(Alert);
Vue.use(Confirm);
Vue.use(Toast);
Vue.use(Loading)

Vue.use(require('vue-wechat-title'));

Vue.use(VueRouter);

Vue.prototype.global = global;

Vue.config.ignoredElements = ['wx-open-launch-weapp']


const router = new VueRouter({
  routes,
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
})


router.beforeEach((to, from, next) => {

  const query = Qs.parse(location.href.split('#')[1].split('?')[1]);
  let scenicKey = query.scenicKey || GetQueryString("scenicKey") || "";
  let scenicId = query.scenicId || GetQueryString("scenicId") || "";
  if(scenicKey){
    setStore("scenicKey", {"scenicKey": scenicKey});
  }else{
    setStore("scenicKey", {"scenicKey":""});
  }
  wxInitial();

  //let userInfo = {
  //  //openid: "oUzJo5Hhau_Waog3gjN2TQ76vobc", //张彪
  //  openid: "oUYE8xN4ZRA-u53-uR_qP7GeLJu8", //黄月
  //  //openid: "oUYE8xAcdtX4XuHZWQed8BHuWCY0", //小包
  //  //openid: "oUYE8xFTWojPxEww36urMQrLgPBQ", //小小黄
  //  //openid: "123456", //黄月
  //  //openid: "123451", //黄月
  //  //openid: "oUYE8xOkfCRRKQwYbA1HUiyUnaQE", //何放
  //  headimg: "http://thirdwx.qlogo.cn/mmopen/vi_32/1uQhUgz5gMf1gUChJvtiaiaS1picK1go1mWgic6w4ibQZIu7M5TBXhB5XvfSaHcoYFiatwlR3VMqib4t3SVnt2nZCQKuw/132",
  //  utype: "user",
  //  city: "成都",
  //  jointime: "2018-11-06 12:51:13",
  //  gender: 1,
  //  istui: 0,
  //  unionId: "oINhv0zA9xZ0xGvSvmEX6I6Lx5Gw",
  //  uptime: "2018-11-06 14:32:57",
  //  name: "缺心眼子",
  //  id: 53891,
  //  state: 1
  //};
  //setStore("userInfo", userInfo)
  //if (to.meta.title) { document.title = to.meta.title; }
  //scenicAuth();

  if(to.path == '/order-team-index'){
    next();
    return false;
  }else {
    try {
      let userInfo =  getStore("userInfo") || '';
      let userInfo1 =  getStore("userInfo1",1);

      if((userInfo1 && userInfo1.openid) || (userInfo && userInfo.openid)){

        let timeNow = new Date().getTime();
        let timelogin = parseInt((getStore("timelogin",1)&&getStore("timelogin",1).timelogin) || 0);
        if(timelogin==0 || (timelogin>0 && (timeNow-timelogin)>1000*3600*24*10) ){//保存登录状态10天
          removeStore("userInfo");
          removeStore("userInfo1",1);
          removeStore("timelogin",1);
          toNext();
        }else {
          if(userInfo1 && userInfo1.openid){
            setStore("userInfo", userInfo1);
          }else {
            setStore("userInfo1", userInfo,1);
          }
          if (to.meta.title) { document.title = to.meta.title; }
          scenicAuth()
        }
      }else {
        toNext();
      }
    } catch (e) {
      toNext();
    }
  }

  function toNext(){
    let hash = window.sessionStorage.getItem("hash");
    if(hash == "" || hash == null){
      hash = location.href.split('#')[1];
      window.sessionStorage.setItem("hash", hash);
    }
    if(to.path == '/400'||to.path == '/401'){
      next();
    }else {
      getWxAuth(function (data) {
        if (data.status == 200 && data.data.errcode === '00000') {
          setStore("timelogin",{timelogin: new Date().getTime()},1);
          setStore("userInfo", data.data.data);
          setStore("userInfo1", data.data.data,1);

          if (to.meta.title) { document.title = to.meta.title; }
          window.location.replace(location.href.split('#')[0].split('?')[0]+'#'+hash);
          window.sessionStorage.setItem("hash", "");

          scenicAuth()
        }else {
          next({
            path: '/400'
          })
        }
      })
    }
  }

  //是否需要景区授权
  function scenicAuth(){
    if(scenicKey && scenicId){
      checkScenicAuth(scenicKey,scenicId,function(data){
        if (data.status == 200) {
          if(data.data.errcode === '00000'){  //需要授权
            var appdata = data.data.data;

            let hash = window.sessionStorage.getItem("hash");
            if(hash == "" || hash == null){
              hash = location.href.split('#')[1];
              window.sessionStorage.setItem("hash", hash);
            }

            getScenicAuth(scenicKey,appdata,function (data) {
              if (data.status == 200 && data.data.errcode === '00000') {
                if (to.meta.title) { document.title = to.meta.title; }
                window.location.replace(location.href.split('#')[0].split('?')[0]+'#'+hash);
                window.sessionStorage.setItem("hash", "");

                next();
                return false;
              }else {
                next({
                  path: '/401'
                })
              }
            })

          }else {
            next();
            return false;
          }
        }else {
          next({
            path: '/401'
          })
        }
      });
    }else {
      next();
      return false;
    }
  }


});

new Vue({
  store,
  router,
  el: '#root',
  components: {
    App
  },
  template: '<App/>'
})
// const root = document.getElementById('root');
// console.log(root);





// WEBPACK FOOTER //
// ./src/main.js